import _styled from "styled-components";
import React from "react";
export type PointCloudBottomMediaViewProps = {
  media?: React.ReactNode;
};
export function PointCloudBottomMediaView({
  media
}: PointCloudBottomMediaViewProps) {
  if (!media) {
    return null;
  }
  return <_StyledDiv>{media}</_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "point-cloud-bottom-media___StyledDiv",
  componentId: "sc-lfbtmn-0"
})({
  "width": "9.2rem",
  "borderWidth": "1px",
  "borderColor": "currentColor",
  "@media (min-width: 1024px)": {
    "width": "19.2rem"
  }
});